var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-delete-wrapper"},[_c('div',{staticClass:"delete-button-wrapper",class:{
      growDeleteAnim: _vm.animationStatus == 1,
      ungrowDeleteAnim: _vm.animationStatus > 1,
    }},[_c('div',{staticClass:"trash-wrapper",on:{"click":_vm.iconClicked}},[(_vm.animationStatus == 4)?_c('i',{staticClass:"fas fa-exclamation text-danger",staticStyle:{"margin-left":"4px","margin-right":"4px"}}):(_vm.animationStatus == 3)?_c('i',{staticClass:"bx bx-loader-alt bx-spin text-warning",staticStyle:{"margin-left":"-4px","font-size":"18px"}}):_c('i',{class:_vm.animationStatus == 0
            ? _vm.iconClass
            : _vm.animationStatus == 2
            ? Object.assign({}, _vm.iconClass, {deleteButtonUnAnim: true})
            : {
                fas: true,
                'fa-times': true,
                'text-danger': true,
                deleteButtonAnim: true,
              }})]),_c('span',{staticClass:"confirm-text text-success",class:{ 'extra-padding': _vm.$t('general.confirmInterog').length < 9 },on:{"click":function($event){return _vm.confirmClicked()}}},[_vm._v(" "+_vm._s(_vm.$t('general.confirmInterog'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }